import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';
import Modal from 'react-modal';

import ScrollToTop from './components/ScrollToTop';
import Header from './components/Header.jsx';
import Footer from './components/Footer';

import Home from './pages/Home';
import About from './pages/About';
import Rooms from './pages/Rooms';
import RoomDeluxe from './pages/RoomDeluxe';
import RoomTwin from './pages/RoomTwin';
import RoomKing from './pages/RoomKing';
import RoomStandard from './pages/RoomStandard';
import ConferenceHall from './pages/ConferenceHall';
import ContactPage from './pages/ContactPage';
import NewsEventsPage from './pages/NewsEventsPage';
import BarRestaurant from './pages/BarRestaurant';
import DiningRestaurant from './pages/DiningRestaurant';
import OtherServicesDetail from './pages/OtherServices';
import PrivacyPolicy from './pages/PrivacyPolicy';

// Admin

import Dashboard from './admin/Dashboard';
import ProtectedRoute from './admin/ProtectedRoute';
import AdminLogin from './admin/AdminLogin';

import { HelmetProvider } from 'react-helmet-async';

const App = () => {
  const [language, setLanguage] = useState(null); // Initially null
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedLang = localStorage.getItem('preferredLanguage') || 'en';
    setLanguage(storedLang);
    setLoading(false); // Done loading
    AOS.init({ duration: 1000, once: true });
    Modal.setAppElement('#root');
  }, []);

  const toggleLanguage = () => {
    const newLang = language === 'am' ? 'en' : 'am';
    setLanguage(newLang);
    localStorage.setItem('preferredLanguage', newLang);
  };



  const isAdminPath = window.location.pathname.startsWith('/admin');

  if (loading) return null; // Don't render anything until language is ready



  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        {!isAdminPath && <Header language={language} onLanguageChange={toggleLanguage} />}
        <Routes>
          <Route path="/" element={<Home language={language} />} />
          <Route path="/about" element={<About language={language} />} />
          <Route path="/rooms" element={<Rooms language={language} />} />
          <Route path="/rooms/deluxe" element={<RoomDeluxe language={language} />} />
          <Route path="/rooms/twin" element={<RoomTwin language={language} />} />
          <Route path="/rooms/king" element={<RoomKing language={language} />} />
          <Route path="/rooms/standard" element={<RoomStandard language={language} />} />
          <Route path="/contact" element={<ContactPage language={language} />} />
          <Route path="/conference" element={<ConferenceHall language={language} />} />
          <Route path="/news-events" element={<NewsEventsPage language={language} />} />
          <Route path="/bar" element={<BarRestaurant language={language} />} />
          <Route path="/dining" element={<DiningRestaurant language={language} />} />
          <Route path="/other-services" element={<OtherServicesDetail language={language} />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy language={language} />} />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        {!isAdminPath && <Footer language={language} />}
      </Router>
    </HelmetProvider>
  );
};


export default App;
